type OptionsParam = {
    minDecimals?: number;
    maxDecimals?: number;
    minValue?: number;
    currency?: 'USD' | '';
    useGrouping?: boolean;
};

const formats = [
    {
        number: 1_000_000_000,
        formatLabel: 'B',
    },
    {
        number: 1_000_000,
        formatLabel: 'M',
    },
    {
        number: 1000,
        formatLabel: 'K',
    },
];

const formatAmountWithSuffix = (
    value: number | string,
    options: OptionsParam = {
        minDecimals: 0,
        maxDecimals: 2,
        currency: '',
        useGrouping: true,
    }
): string => {
    let {
        minDecimals = 0,
        maxDecimals = 2,
        minValue,
        currency = '',
        useGrouping = true,
    } = options;

    if (!value && value !== 0) {
        console.error('formatAmountWithSuffix: Value is not defined');
        value = 0;
    }

    if (isNaN(+value)) {
        console.error('formatAmountWithSuffix: Value is not a number');
        value = 0;
    }

    if (maxDecimals < minDecimals) {
        console.error(
            'formatAmountWithSuffix: maxDecimals cannot be lesser than minDecimals'
        );
        maxDecimals = minDecimals;
    }

    const parsedValue = +value;

    let output: string;

    if (minValue && Math.abs(parsedValue) < minValue) {
        output = parsedValue.toLocaleString('en-US', {
            minimumFractionDigits: minDecimals,
            maximumFractionDigits: maxDecimals,
            ...(currency && { style: 'currency', currency }),
            useGrouping,
        });
    } else {
        for (const format of formats) {
            output = `${(parsedValue / format.number).toLocaleString('en-US', {
                minimumFractionDigits: minDecimals,
                maximumFractionDigits: maxDecimals,
                ...(currency && { style: 'currency', currency }),
                useGrouping,
            })}${format.formatLabel}`;

            if (Math.abs(parsedValue) >= format.number) {
                break;
            }
        }
    }

    return output!;
};

export default formatAmountWithSuffix;
